import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=41b8ea16&scoped=true&"
import script from "./announcement.vue?vue&type=script&lang=js&"
export * from "./announcement.vue?vue&type=script&lang=js&"
import style0 from "./announcement.vue?vue&type=style&index=0&id=41b8ea16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b8ea16",
  null
  
)

export default component.exports